import { switchCampus } from '../db';

// The ONE way to change campus. The database moves the user's active campus (users.school_id and
// role), then the page reloads so every store, cache and subscription starts clean for the new campus.
// Per-school browser data is namespaced (utils/schoolStorage.js), so nothing needs to be deleted.
export async function switchAndReload(schoolId, name) {
  await switchCampus(schoolId);
  try { sessionStorage.setItem('switchedCampus', name || ''); } catch { /* storage blocked */ }
  window.location.reload();
}

// Read once after the reload to say where the user landed.
export function takeSwitchedCampusName() {
  try {
    const n = sessionStorage.getItem('switchedCampus');
    sessionStorage.removeItem('switchedCampus');
    return n || null;
  } catch { return null; }
}
